export enum FiscalYearState {
    Open = "Open",
    Closed = "Closed",
    Closing = "Closing"
}

export const FiscalYearStateLabels: Record<FiscalYearState, string> = {
    [FiscalYearState.Open]: 'Open',
    [FiscalYearState.Closed]: 'Closed',
    [FiscalYearState.Closing]: 'Closing'
};

export interface FiscalYear {
    id: string;
    name: string;
    start: string;
    end: string;
    state: FiscalYearState;
}
